export enum GetApplicationListType {
  Open = 1, //Open is treated as mine in backend 
  All = 2,
  Assigned = 3
}
